module.exports = __webpack_public_path__ + "media/luxury-2026/drone-photo-interior-960-40e98901.jpg";